// EmptyState — shared placeholder for pages/sections with no data yet.
// Uses the .empty-state* classes ported from Tally.

import type { ReactNode } from "react";

export function EmptyState({
  title,
  children,
  action,
  error,
}: {
  title: string;
  children?: ReactNode;
  action?: ReactNode;
  /** The request failed. Say so, rather than implying there is no data. */
  error?: boolean;
}) {
  if (error) {
    return (
      <div className="empty-state">
        <div className="empty-state-title">Couldn't load this</div>
        <div className="empty-state-body">
          The request to the API failed, so this may not be empty at all. If it keeps
          happening, sign out and back in.
        </div>
        <div className="mt-4">
          <button type="button" className="btn-secondary" onClick={() => window.location.reload()}>
            Try again
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="empty-state">
      <div className="empty-state-title">{title}</div>
      {children && <div className="empty-state-body">{children}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

// PageHeader — consistent page title + optional eyebrow/action row.
export function PageHeader({
  title,
  eyebrow,
  action,
}: {
  title: string;
  eyebrow?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="mb-5 flex items-start justify-between gap-3">
      <div>
        {eyebrow && <div className="eyebrow mb-1">{eyebrow}</div>}
        <h1 className="page-title">{title}</h1>
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
